// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_6c97079b1b--tooltip--M1G81","arrow_tooltip":"_6c97079b1b--arrow_tooltip--xm3aH","arrow":"_6c97079b1b--arrow--QDoVo"};